export default __webpack_public_path__ + "static/media/ferocioussmack.2c14eec0.png";